<template>
  <section class="card">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'CuCard'
}
</script>

<style lang="scss" scoped>
@import "../styles/colors.scss";

.card {
  padding: 1.6rem;
  margin: 0 0.8rem;
  background-color: #fff;
  box-shadow: 0 1px 0 0 $border-gray;
}
</style>
